import * as bank from "../types/bank";

export const setName = name => ({
    type: bank.SET_NAME,
    payload: { name }
});

export const setInfo = info => ({
    type: bank.SET_INFO,
    payload: { info }
});

export const reset = () => ({
    type: bank.RESET
});
